jQuery(document).ready(function($) {

  $('select.field__input').on( "change", function() {
    $(this).parent().find('label').css('visibility', 'hidden');
  });
  
  const customCursor = new dpkCursor({ ease: 0.08 });
  
  var heading = $('.layout_home_hero .banner__heading');
  var text = heading.text();
  var words = text.split(' ');
  var html = '';
  for (var i = 0; i < words.length; i++) {
      html += '<span class="mask"><span class="word" style="animation-delay: ' + (i * 0.5) + 's;">' + words[i] + '</span></span>';
  }
  heading.html(html);
  
  setTimeout(function() {
    $('.layout_home_hero .banner__heading').css('opacity', '1');
    $('.word').each(function(index) {
      $(this).css('animation', 'slideUpAnimation 0.5s ease forwards');
      $(this).css('animation-delay', (index * 0.2) + 's'); // Apply individual animation delay
    });
  }, 500); // Adjust the delay as needed

  
  $( "section" ).each(function( index ) {
    if ( $('.big__heading', this).length) {
      var big_heading = $('.big__heading', this);
      console.log(big_heading);
      var big_text = big_heading.text().trim();
      var big_words = big_text.split(' ');
      var big_html = '';
      for (var i = 0; i < big_words.length; i++) {
          big_html += '<span class="mask"><span class="word" style="animation-delay: ' + (i * 0.5) + 's;">' + big_words[i] + '</span></span>';
      }
      big_heading.html(big_html);
      
      setTimeout(function() {
        $('.big__heading').css('opacity', '1');
        $('.word').each(function(index) {
          $(this).css('animation', 'slideUpAnimation 0.5s ease forwards');
          $(this).css('animation-delay', (index * 0.2) + 's'); // Apply individual animation delay
        });
      }, 500); // Adjust the delay as needed
    }
  });


  $(window).scroll(function() {
    var scrollTop = $(this).scrollTop();

    $('.parallax').each(function() {
      var speed = parseFloat($(this).attr('data-speed'));
      var yPos = -scrollTop / speed;

      $(this).css({
        'transform': 'translateY(' + yPos + 'px)'
      });
    });
  });

  
  // (function () { 
  //   setTimeout(function() { 
	 //    var scroll = new LocomotiveScroll(); 
  // 	}, 2000); 
  // })();


  var fly = '<img src="https://cdn.shopify.com/s/files/1/0638/3520/9878/files/idle-fly.svg" width="300">';
  $(document).idle({
    onIdle: function(){
      //console.log('Idle!');

      var x = 0;
      $('#idle').addClass('active');
      
      var refreshIntervalId = setInterval(function() {
        //console.log('Still Idle!');

        if(x < 20) {
          // Create a fly element from the 'fly' variable
          var flyElement = $(fly);
          // Generate random coordinates for the fly
          var randomX = Math.floor(Math.random() * ($(window).width() - flyElement.width()));
          var randomY = Math.floor(Math.random() * ($(window).height() - flyElement.height()));
          // Set the position of the fly
          flyElement.css({ top: randomY, left: randomX });
          // Rotate the fly image
          var rotation = Math.random() * 360; // Generate a random rotation angle
          flyElement.css({ transform: 'rotate(' + rotation + 'deg)' });
          // Append the fly to the #idle div
          $('#idle').append(flyElement);
        }
        x++;
      }, 15000);
  
      this.refreshIntervalId = refreshIntervalId;
    
    },
    onActive: function(){
      clearInterval(this.refreshIntervalId);
      console.log('Active!');
      
      // Loop through each fly element and disperse it in a random direction
      $('#idle').children('img').each(function() {
        //console.log('h');
          var fly = $(this);
          var deltaX = Math.random() * 4000 - 2000; // Generate a random X displacement between -100 and 100
          var deltaY = Math.random() * 4000 - 2000; // Generate a random Y displacement between -100 and 100
          var newX = parseFloat(fly.css('left')) + deltaX;
          var newY = parseFloat(fly.css('top')) + deltaY;
          
          // Update the position of the fly
          fly.animate({ left: newX, top: newY }, 500, function() {
              // Remove the fly element after animation is complete
              //fly.remove();
          });
      });
  
       setTimeout(function() { 
        $('#idle').empty();
        $('#idle').removeClass('active');
      }, 500);
  
  
      // Clear the setInterval function to stop adding flies
      // clearInterval(this.refreshIntervalId);

    },
    idle: 60000,
    keepTracking: true
  });

  $(document).on('click', '.video_trigger', function() {
    var video_id = $(this).attr('video-id');
    $('body').addClass('locked');
    $('.video_layout_overlay').addClass('active');
    $('.video_holder').addClass('active');
    $('iframe[data-media-id="' + video_id + '"]').toggleClass('active');
  });
  
  $(document).on('click', '.multirow .close-video', function() {
    $('.video_layout_overlay').removeClass('active');
    $('.video_holder').removeClass('active');
    $('iframe').removeClass('active'); 
    $('body').removeClass('locked');
  });

  $(document).on('click', '.video_layout_overlay .clicker', function() {
    $('body').addClass('locked');
    $('.video_layout_overlay').addClass('active');
    $(this).parent().find('.video_holder').addClass('active');
  });
  $(document).on('click', '.video_layout_overlay .close-video', function() {
    $('.video_layout_overlay').removeClass('active');
    $(this).parent().removeClass('active');
    $('body').removeClass('locked');
  });

});